import { render } from "./IconTrekBeltDrive.vue?vue&type=template&id=33d8710c"
import script from "./IconTrekBeltDrive.vue?vue&type=script&lang=js"
export * from "./IconTrekBeltDrive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__